import React from "react";
import Services from "../home/services";

// Network Services Schemas
export const EnterpriceConnectivity = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Reliable Enterprise Connectivity for Uninterrupted Performance",
         "description": "Boost business performance with dedicated internet, leased lines, MPLS VPN, and managed SD-WAN solutions. Reliable enterprise connectivity tailored to your needs.",
          "url": "https://ishantechnologies.com/network-services/enterprise-connectivity",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const UnifiedCommunication = () => {
    const schema = { 
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Ishan CXConnect: Integrated Communications for Better Collaboration",
         "description": "Experience communication with Ishan Technologies, your trusted unified communication service provider. Explore enterprise solutions & collaboration services.",
          "url": "https://ishantechnologies.com/network-services/unified-communication",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const HighSpeedBroadband = () => {
    const schema = { 
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Cutting-Edge High-Speed Broadband for Uninterrupted Connectivity",
         "description": "Choose Ishan Technologies for cutting-edge high-speed broadband services. We are your dedicated broadband service providers in India. Connect us now!",
          "url": "https://ishantechnologies.com/network-services/high-speed-broadband",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const HighSpeedBroadband_Plans = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Flexible High-Speed Broadband Plans for Every Business Need",
         "description": "Discover high-speed broadband plans tailored for your needs. Ishan Technologies offers retail and unlimited broadband plans in India. Connect us today!",
          "url": "https://ishantechnologies.com/network-services/high-speed-broadband/plans",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
         },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
    }

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const CarrierBasedCloud = () => {
    const schema = {  
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Carrier-Based Cloud Solutions for Reliable Connectivity",
        "description": "Seamless, high-speed connections with Google, AWS, Azure, and Oracle for optimized cloud performance.",
         "url": "https://ishantechnologies.com/network-services/carrier-based-cloud",
        "provider": {
          "@type": "Organization",
          "name": "Ishan Technologies",
          "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// Data Center Services Schemas
export const Colocation = () => {
    const schema = { 
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Top Colocation Provider for Hosting & Data Center Solutions",
         "description": "Optimize IT management with Ishan Technologies' secure and reliable colocation services. Leverage our data center to protect IT assets and scale operations seamlessly.",
          "url": "https://ishantechnologies.com/data-center-services/colocation",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

// System Integration Schemas
export const ManagedServices = () => {
    const schema = {
         "@context": "https://schema.org",
         "@type": "Service",
         "name": "Trusted Managed Service Provider (MSP) for Scalable Growth",
         "description": "End-to-end IT management with expert support, tailored solutions, and governance to ensure security, scalability, and compliance.",
          "url": "https://ishantechnologies.com/systems-integration/managed-services",
         "provider": {
           "@type": "Organization",
           "name": "Ishan Technologies",
           "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}

    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const SecureAndScalableDigital = () => {
    const schema = {  
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Secure and Scalable Digital Network Design and Implementation",
        "description": "With Ishan Technologies, you experience Secure and Scalable Digital Network Services, which are meticulously tailored to your business needs. Our comprehensive offerings encompass network design, implementation, and integration, spanning active, passive, and Wi-Fi networks.",
         "url": "https://ishantechnologies.com/systems-integration/secure-and-scalable-digital",
        "provider": {
          "@type": "Organization",
          "name": "Ishan Technologies",
          "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const DataLifeCycleSolutions = () => {
    const schema = {  
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Comprehensive Data Management for Servers and Storage",
        "description": "Experience excellence in data lifecycle services with Ishan Technologies. We offer innovative solutions, including tech data lifecycle and cloud secure services.",
         "url": "https://ishantechnologies.com/systems-integration/data-lifecycle-solutions",
        "provider": {
          "@type": "Organization",
          "name": "Ishan Technologies",
          "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}

export const SmartCityServices = () => {
    const schema = { 
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "Smart Urban Infrastructure for Connected Cities",
        "description": "Powering 11+ smart cities in India making them smarter and safer with OFC, connectivity, command control, CCTV, smart lighting, and more.",
         "url": "https://ishantechnologies.com/systems-integration/smart-city-services",
        "provider": {
          "@type": "Organization",
          "name": "Ishan Technologies",
          "url": "https://ishantechnologies.com/"
        },
        "image": "https://ishantechnologies.com/api/static/12449ishan_305_39_png.png" 
}
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
}
